module.exports = __webpack_public_path__ + "media/images/en_flag-c07aae7df1239dc77066e9920300212b.png";